import { render, staticRenderFns } from "./DoctorRecommendReward.vue?vue&type=template&id=01d50deb&scoped=true"
import script from "./DoctorRecommendReward.vue?vue&type=script&lang=js"
export * from "./DoctorRecommendReward.vue?vue&type=script&lang=js"
import style0 from "./DoctorRecommendReward.vue?vue&type=style&index=0&id=01d50deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d50deb",
  null
  
)

export default component.exports